import React from 'react';
import {useDispatch} from 'react-redux';
import {useTranslation} from 'react-i18next';
import {createPortal} from 'react-dom';
import {deleteSlidesAction} from '../../../../store/actions/slide';
import {ISlide} from '../../../../incase-domain/slide';
import ConfirmModal from '../../../../incase-domain/components/modals/confirmModal/ConfirmModal';

interface DeleteSlideModalProps {
    deleteModalOpen: boolean;
    setDeleteModalOpen: (open: boolean) => void;
    slides: ISlide[];
}

function DeleteSlideModal({deleteModalOpen, setDeleteModalOpen, slides}: DeleteSlideModalProps): JSX.Element {
    const {t} = useTranslation();
    const dispatch = useDispatch();
    const isBatch = slides.length > 1;

    function handleConfirm(): void {
        dispatch(deleteSlidesAction(slides));
        setDeleteModalOpen(false);
    }

    return createPortal(
        <ConfirmModal
            isOpen={deleteModalOpen}
            onCancel={() => setDeleteModalOpen(false)}
            onConfirm={handleConfirm}
            message={isBatch ? t('presEditPage.deleteSlidesModalText', {count: slides.length}) : t('presEditPage.deleteSlideModalText')}
            title={isBatch ? t('presEditPage.deleteSlidesModalTitle') : t('presEditPage.deleteSlideModalTitle')}
            color="error"
            showConfirm
            showCancel
            confirmText={t('presEditPage.delete')}
            cancelText={t('presEditPage.cancel')}
        />,
        document.body
    );
}

export default DeleteSlideModal;
